import * as React from "react";

import { cn } from "@/lib/utils";
import { FORM_CONTROLS } from "@/design-system";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Show error validation styling */
  error?: boolean;
  /** Show success validation styling */
  success?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, success, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
          error && FORM_CONTROLS.validation.error,
          success && !error && FORM_CONTROLS.validation.success,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

const ChatTextarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, name, error, success, ...props }, ref) => {
    const randomName = React.useMemo(
      () => name || `chat-textarea-${Math.random().toString(36).slice(2)}`,
      [name]
    );

    return (
      <textarea
        ref={ref}
        name={randomName}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
          error && FORM_CONTROLS.validation.error,
          success && !error && FORM_CONTROLS.validation.success,
          className,
        )}
        {...props}
      />
    );
  }
);
ChatTextarea.displayName = "ChatTextarea";

export { Textarea, ChatTextarea };
